const subscribers = new Set();

export function subscribeFeedback(cb) {
  subscribers.add(cb);
  return () => subscribers.delete(cb);
}

export function emitFeedback(payload) {
  subscribers.forEach((cb) => {
    try {
      cb(payload);
    } catch (_e) {
      // ignore subscriber errors
    }
  });
}

